import React from 'react';
import { NavLink } from 'react-router-dom';
import { useAuth } from '../useAuth';

const linkClass = ({ isActive }) =>
  `block px-3 py-2 rounded text-sm transition-colors ${
    isActive
      ? 'bg-neutral-800 text-neutral-100'
      : 'text-neutral-400 hover:bg-neutral-900 hover:text-neutral-200'
  }`;

export default function Sidebar() {
  const { signOut } = useAuth();
  return (
    <aside className="w-56 shrink-0 border-r border-neutral-800 bg-neutral-950 flex flex-col">
      <div className="px-6 py-6">
        <h1 className="text-lg font-semibold">ShrewdHedge</h1>
      </div>
      <nav className="flex-1 px-3 flex flex-col gap-1">
        <NavLink to="/dashboard" className={linkClass}>
          Dashboard
        </NavLink>
        <NavLink to="/research" className={linkClass}>
          Deep research
        </NavLink>
      </nav>
      <div className="p-3 border-t border-neutral-800">
        <button
          onClick={signOut}
          className="block w-full text-left px-3 py-2 rounded text-sm text-neutral-400 hover:bg-neutral-900 hover:text-neutral-200"
        >
          Sign out
        </button>
      </div>
    </aside>
  );
}
